import { isAbsoluteUrl } from "./check-url";

export const buildUrl = ({
  target = "",
  proxyBaseUrl = "",
  stringToJoin = ""
}) => {
  const newUrl = [
    proxyBaseUrl,
    stringToJoin || target.replace("://", "/")
  ].join("/");

  return isAbsoluteUrl(target) ? target : newUrl;
};
